// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getRegistros as listRegistrosAPI,
    getDataCharts as getDataChartsAPI,
    getDataChartsComparisons as getDataChartsComparisonsAPI,
    getRegistrosForExcel as getRegistrosForExcelAPI,
    getRegistrosForExcelRA as getRegistrosForExcelRAAPI,
    getRegistrosItSendStat as getRegistrosItSendStatAPI,
    addRegistro as addRegistroAPI,
} from '../../helpers/';

import { registrosApiResponseError, registrosApiResponseSuccess } from './actions';
import { RegistrosActionTypes } from './constants';


function* addRegistro({payload:registro}){
    try{
        const response = yield call(addRegistroAPI,{...registro})
        const registroItem = response?.data?.data ?? response?.data?.id ?? response?.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.ADD_REGISTRO,registroItem))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.ADD_REGISTRO,error))
    }
}

function* listRegistros({payload:params}) {
    try {
        const response = yield call(listRegistrosAPI, { ...params });
        const listaRegistros = response.data.data;
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.LIST_REGISTROS, listaRegistros));
    } catch (error) {
        yield put(registrosApiResponseError(RegistrosActionTypes.LIST_REGISTROS, error));
    }
}

function* getDataCharts({payload:params}){
    try{
        const response = yield call(getDataChartsAPI,{...params})
        const dataCharts = response.data.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.GET_DATA_CHARTS,dataCharts))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.GET_DATA_CHARTS,error))
    }
}

function* getDataChartsComparisons({payload:params}){
    try{
        const response = yield call(getDataChartsComparisonsAPI,{...params})
        const dataChartsComparisons = response.data.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS,dataChartsComparisons))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS,error))
    }
}

function* getRegistrosForExcel({payload:params}){
    try{
        const response = yield call(getRegistrosForExcelAPI,{...params})
        const registrosForExcel = response.data.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL,registrosForExcel))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL,error))
    }
}

function* getRegistrosForExcelRA({payload:params}){
    try{
        const response = yield call(getRegistrosForExcelRAAPI,{...params})
        const registrosForExcelRA = response.data.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA,registrosForExcelRA))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA,error))
    }
}

function* getRegistrosItSendStat({payload:params}){
    try{
        const response = yield call(getRegistrosItSendStatAPI,{...params})
        const registrosItSendStat = response.data.data
        yield put(registrosApiResponseSuccess(RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT,registrosItSendStat))
    } catch(error){
        yield put(registrosApiResponseError(RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT,error))
    }   
}
    
export function* watchListRegistros(): any {
    yield takeEvery(RegistrosActionTypes.LIST_REGISTROS, listRegistros);
}

export function* watchAddRegistro():any{
    yield takeEvery(RegistrosActionTypes.ADD_REGISTRO,addRegistro)
}

export function* watchGetDataCharts():any{
    yield takeEvery(RegistrosActionTypes.GET_DATA_CHARTS,getDataCharts)
}

export function* watchGetDataChartsComparisons():any{
    yield takeEvery(RegistrosActionTypes.GET_DATA_CHARTS_COMPARISONS,getDataChartsComparisons)
}

export function* watchGetRegistrosForExcel():any{
    yield takeEvery(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL,getRegistrosForExcel)
}

export function* watchGetRegistrosForExcelRA():any{
    yield takeEvery(RegistrosActionTypes.GET_REGISTROS_FOR_EXCEL_RA,getRegistrosForExcelRA)
}

export function* watchGetRegistrosItSendStat():any{
    yield takeEvery(RegistrosActionTypes.GET_REGISTROS_IT_SEND_STAT,getRegistrosItSendStat)
}

function* registrosSaga(): any {
    yield all([
        fork(watchListRegistros),
        fork(watchAddRegistro),
        fork(watchGetDataCharts),
        fork(watchGetDataChartsComparisons),
        fork(watchGetRegistrosForExcel),
        fork(watchGetRegistrosForExcelRA),
        fork(watchGetRegistrosItSendStat)
    ]);
}

export default registrosSaga;